import '@styles/main.css';
import { setFooterYear } from './modules/footer-year.js';
import { initNav } from './modules/nav.js';
import { initCommandBar } from './modules/command-bar.js';
import { initCarousel } from './modules/carousel.js';
import { initForms } from './modules/forms.js';
import { initAnimations } from './modules/animations.js';
import { initLattice } from './modules/lattice.js';
import { initDocs } from './modules/docs.js';
import { initLoader } from './modules/loader.js';

document.addEventListener('DOMContentLoaded', () => {
  initLoader();
  setFooterYear();
  initNav();
  initLattice();
  initCommandBar();
  initCarousel();
  initForms();
  initDocs();
  initAnimations();
});
